module.exports = __webpack_public_path__ + "e2670b19fba34c9d0ac3db2596654b7b.svg";